import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { ReadOnlyInput, ReadOnlyTextarea } from "../ui/ReadOnly";
import styles from "../../styles/evento-detalle.module.css";


const isImageUrl = (url = "") => /\.(png|jpe?g|gif|webp)$/i.test(url.split("?")[0]);
const isPdfUrl = (url = "") => /\.pdf$/i.test(url.split("?")[0]);

export function TabDatos({ evento, agentesLabel }) {
    const docUrl = evento?.rutaDocumento || "";


    return (
        <Section>
            <div className={styles["grid-3"]}>
                <Field label="Nombre del evento">
                    <ReadOnlyInput value={evento.nombre || ""} />
                </Field>

                <Field label="Fecha de inicio">
                    <ReadOnlyInput value={evento.fechaInicio ? evento.fechaInicio.split("T")[0] : ""} />
                </Field>

                <Field label="Fecha de fin">
                    <ReadOnlyInput value={evento.fechaFin ? evento.fechaFin.split("T")[0] : ""} />
                </Field>
            </div>

            <Field label="Observación">
                <ReadOnlyTextarea value={evento.descripcion || ""} />
            </Field>

            <div className={styles["grid-2"]}>
                <Field label="Estado">
                    <ReadOnlyInput value={evento.esProvisional ? "Provisional / Reserva" : "Definitivo"} />
                </Field>

                <Field label="Agente(s)">
                    <ReadOnlyInput value={agentesLabel} />
                </Field>
            </div>

            <div style={{ marginTop: 24 }}>
                <Field label="Documento del evento">
                    {!docUrl ? (
                        <div style={{ marginTop: 8 }}>No hay documento</div>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
                            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                                <button className={styles.btn + " " + styles.btnPrimary} onClick={() => window.open(docUrl, "_blank")}>
                                    Ver documento
                                </button>
                            </div>
                        </div>
                    )}
                </Field>


            </div>
        </Section>
    );
}
